// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".organization-page__title{margin:10px;margin-bottom:20px;font-style:normal;font-weight:600;font-size:20px;line-height:24px}\n", ""]);
// Exports
module.exports = exports;
